module.exports = __webpack_public_path__ + "static/media/0036.8594e195.svg";